export default "__VITE_ASSET__DlkiLTqW__"